import ApiHandler from "./ApiHandler";

const Me = {
  getOne: async () => await ApiHandler.i.auth().get('/me'),
  getVerify: async () => await ApiHandler.i.auth().get('/me/verify'),
  putOne: async (data, options) => await ApiHandler.i.auth().put('/me', data, options),
  putPassword: async (data, options) => await ApiHandler.i.auth().put('/me/password', data, options),
  putAvatar: async (data, options) => await ApiHandler.i.auth().put('/me/avatar', data, options),
  postRequest: async (data, options) => await ApiHandler.i.auth().post('/me/request', data, options),
};

export default Me;